window.global ||= window

setTimeout(async () => {
  const { scan } = await import('react-scan')
  scan({
    enabled: import.meta.env.VITE_ENV === 'local',
    trackUnnecessaryRenders: true,
  })
}, 1000)
